/**
 * App Entry File
 * Copyright 2018. All Rights Reserved
 */
/* eslint-disable */
// import 'babel-polyfill'
import Vue from 'vue';
import GlobalComponents from './globalComponents';
import vuetify from '@/plugins/vuetify';
import { store } from './store/store';
import router from './router';
import App from './App.vue';
import './lib/EmbryoCss';
import api from 'Api';

Vue.use(GlobalComponents);

Vue.config.productionTip = false;

Vue.prototype.$eventHub = new Vue();
Vue.prototype.$http = api;

new Vue({
	store,
	router,
	vuetify,
	render: (h) => h(App),
}).$mount('#app');
